import { Blockquote, CaseContainer, CaseSection, Cite, Heading, QuoteMarkLine, Quoteline, Logo } from './styles';
import Cta from '@/components/ui/buttons/Cta';
import Image from 'next/image';
import React from 'react';
import dynamic from 'next/dynamic';

const KeyMark = dynamic(() => import('@/components/ui/icons/KeyMark'), {
  ssr: false,
});
const GpsMark = dynamic(() => import('@/components/ui/icons/GpsMark'), {
  ssr: false,
});
const StethoscopeMark = dynamic(() => import('@/components/ui/icons/StethoscopeMark'), { ssr: false });
const QuoteMark = dynamic(() => import('@/components/ui/icons/QuoteMark'), {
  ssr: false,
});

const getMark = (mark: string) => {
  switch (mark) {
    case 'key':
      return <KeyMark />;
    case 'quote':
      return <QuoteMark />;
    case 'gps':
      return <GpsMark />;
    case 'stethoscope':
      return <StethoscopeMark />;
    default:
      return <QuoteMark />;
  }
};

interface CaseProps {
  heading: string;
  companyName?: string;
  subheading?: string | React.ReactElement;
  ctaUrl?: string;
  attribution?: string | React.ReactElement;
  layout?: 'left' | 'right' | 'center';
  mode?: 'light' | 'dark';
  bgImage?: string;
  logo?: string;
  widerLogo?: boolean;
  longContent?: boolean;
  useGradient?: 'left' | 'right' | 'bottom';
  gradientColor?: string;
  useMobileGradient?: boolean;
  bgPositionTwo?: boolean;
  ctaText?: string;
  mark?: string;
}
const CaseComponent: React.FC<CaseProps> = ({
  heading,
  subheading,
  ctaUrl,
  ctaText,
  attribution,
  companyName,
  layout = 'left',
  widerLogo = false,
  longContent = false,
  mode = 'light',
  bgImage,
  logo,
  useGradient,
  gradientColor,
  useMobileGradient,
  bgPositionTwo,
  mark = 'quote',
}) => {
  return (
    <CaseSection>
      <CaseContainer
        layout={layout}
        bgImage={bgImage}
        useGradient={useGradient}
        gradientColor={gradientColor}
        useMobileGradient={useMobileGradient}
        bgPositionTwo={bgPositionTwo}
      >
        <div className="content-wrapper">
          <Blockquote mode={mode} longContent={longContent}>
            <div className="quote-wrapper">
              <QuoteMarkLine layoutLine={layout} layout={layout} />
              {getMark(mark)}
            </div>
            <Heading mode={mode}>{heading}</Heading>
            {(attribution || companyName) && (
              <Quoteline mode={mode}>
                <>
                  {attribution}
                  <br />
                  <b>{companyName}</b>
                </>
              </Quoteline>
            )}
            <Cite mode={mode}>{subheading}</Cite>
            {logo && (
              <Logo logo={logo} layout={layout} widerLogo={widerLogo}>
                <Image
                  src={logo}
                  alt={companyName || ''}
                  width={widerLogo ? 150 : 90}
                  height={45}
                  style={{ height: 'auto' }}
                />
              </Logo>
            )}
          </Blockquote>
          <div className="cta-wrapper">
            <Cta to={ctaUrl} type="link" hoverMode={mode}>
              {ctaText}
            </Cta>
          </div>
        </div>
      </CaseContainer>
    </CaseSection>
  );
};

export default CaseComponent;
